import { createAction, props } from '@ngrx/store';
import { Page } from '@app/common/page';
import { Order } from '@app/common/order';

export const loadUserOrders = createAction(
  '[Orders] Load User Orders',
  props<{ page: number, size: number }>()
);

export const loadUserOrdersSuccess = createAction(
  '[Orders] Load User Orders Success',
  props<{ orderPage: Page<Order> }>()
);

export const loadUserOrdersFailure = createAction(
  '[Orders] Load User Orders Failure',
  props<{ error: any }>()
);
